import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type VisaType } from '../types'
import { type ResNvcCategoriesQuery } from './types'

export const getNvcCategoriesQuery = (visaType?: VisaType) =>
  queryOptions<ResNvcCategoriesQuery | null>({
    queryKey: [API_ENDPOINTS.business['nvc-category'].index, visaType],
    queryFn: () => w.get(`${API_ENDPOINTS.business['nvc-category'].index}/${visaType}`).json(),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: !!visaType,
  })
